var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDividendsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "url(#paint0_linear_15088_106486)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3196 9.48001C16.0471 8.05348 14.7909 7.1263 14.7382 7.0876C14.4514 6.87732 14.0311 7.06947 14.0311 7.41058V9.21418C14.0311 10.1455 12.7164 10.4733 12.2237 9.6638C12.0705 9.41274 11.698 9.38629 11.5052 9.60715C10.1812 11.1219 9 13.0318 9 14.9982C9 17.8251 11.4532 20.125 14.4686 20.125C17.4839 20.125 19.9371 17.8251 19.9371 14.9982C19.9371 12.9809 18.6947 11.0217 17.3196 9.48001ZM12.0624 13.5627C12.0624 13.1103 12.455 12.7424 12.9374 12.7424C13.4197 12.7424 13.8123 13.1103 13.8123 13.5627C13.8123 14.0152 13.4197 14.383 12.9374 14.383C12.455 14.383 12.0624 14.0152 12.0624 13.5627ZM13.2827 17.0956C13.1352 17.2739 12.8602 17.3071 12.6689 17.1676C12.478 17.0284 12.4438 16.7708 12.592 16.5921L15.6544 12.9008C15.8029 12.7219 16.0777 12.6899 16.2683 12.8288C16.4591 12.968 16.4933 13.2256 16.3451 13.4043L13.2827 17.0956ZM15.9998 17.254C15.5174 17.254 15.1248 16.8861 15.1248 16.4337C15.1248 15.9813 15.5174 15.6134 15.9998 15.6134C16.4821 15.6134 16.8747 15.9813 16.8747 16.4337C16.8747 16.8861 16.4821 17.254 15.9998 17.254Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15088_106486",
    x1: 34.2332,
    y1: 21.7668,
    x2: 21.7668,
    y2: -6.2332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#084034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8E500"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDividendsIcon);
export default __webpack_public_path__ + "static/media/Dividends_Icon.d97a7fcd4e64200f4c8f34fdfb0b6ba4.svg";
export { ForwardRef as ReactComponent };